import { Reveal, SectionTag, Polaroid, Tape, ArrowDoodle } from "@/components/doodles";

const ABOUT_IMG = "/img/about.jpeg";

const STATS = [
  { k: "8 yrs", v: "competitive gymnastics" },
  { k: "'24", v: "CF teen semifinalist" },
  { k: "1 yr", v: "comeback — stronger" },
];

const TRAITS = ["gymnast precision", "NASM certified", "crossfit grit", "faith at the center"];
const TRAIT_STYLES = ["bg-pink text-cream -rotate-2", "bg-electric rotate-1", "bg-gold -rotate-1", "bg-lime rotate-2"];

export const About = () => (
  <section id="about" className="py-24 sm:py-32 relative">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal className="relative">
        <div className="relative w-full max-w-md mx-auto sm:mx-0">
          <Polaroid src={ABOUT_IMG} alt="Rosa sitting on the gym floor smiling" rotate="-rotate-3" caption="gym floor = happy place" className="w-full" />
          <Tape className="-top-3 left-8 -rotate-6" />
          <Tape className="-bottom-2 right-10 rotate-12" />
          <div className="absolute -right-4 sm:-right-8 top-6 bg-lime border-[3px] border-ink px-3 py-2 rotate-6 shadow-[4px_4px_0_#0d0d0d]">
            <p className="font-hand text-xl leading-none">hi, that's me!</p>
          </div>
          <ArrowDoodle className="absolute -right-6 bottom-0 w-20 rotate-[150deg] text-pink hidden sm:block" />
        </div>
      </Reveal>

      <div>
        <Reveal><SectionTag className="text-pink">ABOUT ME</SectionTag></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3 leading-[0.95]">
            MEET ROSA.
            <span className="block text-stroke">COACH. ATHLETE.</span>
            <span className="block">
              PROUD <span className="hl-lime">COMEBACK</span> STORY.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-6 space-y-4 text-base sm:text-lg font-semibold text-ink/75 max-w-xl" data-testid="about-story">
            <p>
              I'm Rosa — <strong className="text-ink">19, NASM-certified personal trainer</strong>, and a sophomore at the{" "}
              <strong className="text-ink">University of Alabama at Birmingham</strong>, studying Kinesiology with a
              concentration in Exercise Science.
            </p>
            <p>
              I spent <strong className="text-ink">8 years as a competitive gymnast</strong> and competed my way to the{" "}
              <strong className="text-ink">CrossFit Teen Semifinals in 2024</strong>. When an injury forced me out of the
              gym for over a year, I learned how to rebuild — patiently, deliberately, and then stronger than before.
            </p>
            <p>
              I bring an <strong className="text-ink">athlete's firsthand experience</strong>, an{" "}
              <strong className="text-ink">evidence-informed education</strong>, and a whole lot of care to every person I coach.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-wrap gap-3" data-testid="about-trait-stickers">
            {TRAITS.map((t, i) => (
              <span key={t} className={`font-hand text-xl sm:text-2xl px-3 py-1 border-[2.5px] border-ink shadow-[3px_3px_0_#0d0d0d] ${TRAIT_STYLES[i]}`}>
                {t}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="about-stats">
            {STATS.map((s) => (
              <div key={s.k} className="border-[3px] border-ink bg-white px-3 py-4 text-center shadow-[4px_4px_0_#0d0d0d]">
                <p className="font-display font-extrabold text-3xl sm:text-4xl leading-none">{s.k}</p>
                <p className="text-[11px] font-bold uppercase tracking-wide text-ink/60 mt-2">{s.v}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
